import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import none from "../../assets/images/none.png";
import jon from "../../assets/images/jon.jpeg";
import eleanor from "../../assets/images/eleanor.jpeg";
import andrea from "../../assets/images/andrea.jpeg";
import anastasia from "../../assets/images/anastasia.jpg";
import johannes from "../../assets/images/johannes.jpg";
import silvia from "../../assets/images/silvia.jpeg";
import ben from "../../assets/images/ben.jpeg";
import naomi from "../../assets/images/naomi.jpeg";
import joshua from "../../assets/images/joshua.jpeg";
import marya from "../../assets/images/marya.png";
import hanlin from "../../assets/images/hanlin.jpeg";
import max from "../../assets/images/max.JPG";

import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  item: {
    borderBottom: "2px #c74375 solid",
    padding: theme.spacing(0.25),
    "@media screen and (max-width: 900px)": {
      padding: 0,
      borderBottom: "1px #c74375 solid",
    },
  },
  cardSpacing: {
    padding: theme.spacing(0.5),
    "@media screen and (max-width: 900px)": {
      padding: theme.spacing(0.75),
    },
  },
  colorRow: {
    backgroundColor: "#fff3ee",
  },
  breakRow: {
    backgroundColor: "#fed7cd",
  },
  sessionRow: {
    backgroundColor: "#fec3c3",
  },
  hiddenXs: {
    "@media screen and (max-width: 900px)": {
      display: "none",
    },
  },
  hiddenMd: {
    "@media screen and (min-width: 900px)": {
      display: "none",
    },
  },
  marginAuto: {
    marginTop: "auto",
    marginBottom: "auto",
  },
  noMargin: {
    margin: 0,
  },
  textLeft: {
    textAlign: "left",
    "@media screen and (max-width: 900px)": {
      textAlign: "center",
    },
  },
  name: {
    "@media screen and (max-width: 900px)": {
      borderBottom: "2px black dotted",
      marginBottom: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
    },
  },
  photo_cont: {
    padding: theme.spacing(0.25),
    "@media screen and (max-width: 900px)": {
      padding: theme.spacing(0),
    },
  },
  photo: {
    borderRadius: "50px",
    height: "60px",
    border: "4px #c74375 solid",
    "@media screen and (max-width: 700px)": {
      height: "50px",
      borderRadius: "100px",
    },
    "@media screen and (max-width: 500px)": {
      height: "40px",
      borderRadius: "50px",
      border: "2px #c74375 solid",
    },
  },
  icon_cont: {
    margin: "16px",
  },
  icon: {
    color: "#c74375 !important",
  },
  larger: {
    height: "70px",
    "@media screen and (max-width: 700px)": {
      height: "60px",
      borderRadius: "100px",
    },
    "@media screen and (max-width: 500px)": {
      height: "50px",
    },
  },
}));

type Props = {
  names: array,
  times: array,
  org: string,
  title: string,
  youtube: string,
};

function Speaker({ names, times, org, title, youtube }: Props) {
  const classes = useStyles();
  const img_files = {
    "Jon Cardoso-Silva": jon,
    "Eleanor Power": eleanor,
    "Andrea Baronchelli": andrea,
    "Naomi Arnold": naomi,
    "Ben Steer": ben,
    "Anastasia Mantziou": anastasia,
    "Silvia Rognone": silvia,
    "Johannes Lumma": johannes,
    "Joshua Becker": joshua,
    "Marya Bazzi": marya,
    "Hanlin Sun": hanlin,
    "Max Falkenberg": max,
  };

  return (
    <>
      <Grid item md={1} xs={0} />
      <Grid
        item
        md={10}
        xs={12}
        className={
          times.length > 0
            ? names.length > 0
              ? classNames(classes.item, classes.colorRow)
              : classNames(classes.item, classes.breakRow)
            : classNames(classes.item, classes.sessionRow)
        }
      >
        <Grid container>
          <Grid item md={1} xs={0} />
          {times.length > 0 ? (
            <Grid item md={2} xs={4} className={classes.marginAuto}>
              <p>{times.join(" - ")}</p>
              <Icons
                names={names}
                youtube={youtube}
                hideClass={classes.hiddenMd}
              />
            </Grid>
          ) : (
            <></>
          )}
          <Grid item md={9} xs={8} className={classes.marginAuto}>
            <Grid container className={classes.cardSpacing}>
              {names.length > 0 ? (
                <Grid item md={4} xs={12} className={classes.photo_cont}>
                  <Grid container>
                    {names.length === 2 ? (
                      <>
                        <Grid item md={3} xs={4} />
                      </>
                    ) : (
                      <></>
                    )}
                    {names.map((image) => (
                      <>
                        <Grid
                          item
                          md={names.length === 2 ? 3 : 12}
                          xs={names.length === 2 ? 2 : 12}
                        >
                          <img
                            className={
                              names.length === 2
                                ? classes.photo
                                : classNames(classes.photo, classes.larger)
                            }
                            alt={img_files[image] ? image : "none"}
                            title={img_files[image] ? image : "none"}
                            src={img_files[image] ? img_files[image] : none}
                          />
                        </Grid>
                      </>
                    ))}
                    <Grid item xs={12}>
                      <p className={classNames(classes.noMargin, classes.name)}>
                        {names.join(" & ")}
                      </p>
                    </Grid>
                    {names.length === 2 ? (
                      <>
                        <Grid item spacing={{ md: 0, xs: 4 }} />
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
              <Grid
                item
                md={6}
                xs={12}
                className={classNames(classes.marginAuto, classes.textLeft)}
              >
                <Grid container>
                  <Grid item xs={12} />
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                        <p className={classes.noMargin}>
                          <strong>{title}</strong>
                        </p>
                      </Grid>
                      <Grid item xs={12}>
                        <p className={classes.noMargin}>
                          <i>{org}</i>
                        </p>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Icons
                names={names}
                youtube={youtube}
                hideClass={classes.hiddenXs}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={1} xs={0} />
    </>
  );
}

function Icons({ names, youtube, hideClass }: Props) {
  const classes = useStyles();
  return (
    <>
      {names.length > 0 ? (
        <Grid
          item
          md={1}
          className={classNames(
            classes.marginAuto,
            classes.icon_cont,
            hideClass
          )}
        >
          <Grid container>
            <Grid item md={0} xs={1} />
            <Grid item md={12} xs={5}>
              <a href={youtube} title="YouTube" className={classes.icon}>
                <FontAwesomeIcon className="fa" icon={faYoutube} size={"2x"} />
              </a>
            </Grid>
            <Grid item md={12} xs={5}>
              <Link
                to={`/files/net_and_time_${names
                  .join("_")
                  .replaceAll(" ", "")}.pdf`}
                target="_blank"
                download
                title="Download Slides"
                className={classes.icon}
              >
                <FontAwesomeIcon className="fa" icon={faDownload} size={"2x"} />
              </Link>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}

export default Speaker;
